import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import mtekLogo from "../../../assets/images/no-quotes.svg";
import { variants } from "../../shared/variants";

function NoQuotesFoundPage() {
  const { t } = useTranslation();

  let reasons = [
    t("quotes.reason1"),
    t("quotes.reason2"),
    t("quotes.reason3"),
  ];

  return (
    <motion.div
      className="no-quotes-container"
      variants={variants}
      initial="enter"
      animate="center"
      exit={{ opacity: 0 }}
    >
      <p className="reg-title" style={{ marginTop: "-2rem" }}>
        <span className="span-title"> {t("quotes.sorryNoQuotes")}</span>
      </p>
      <div className="image mt-2 mb-2">
        <img src={mtekLogo} alt="" />
      </div>
      <div className="no-quotes-reason mt-3">
        <ul>
          {reasons?.map((reason, index) => {
            return <li key={index}>{reason}</li>;
          })}
        </ul>
      </div>
      <div className="no-quotes-description">
        {t("quotes.clickTryAgain")}
      </div>
    </motion.div>
  );
}

export default NoQuotesFoundPage;
